<template>
  <el-breadcrumb separator="/" class="breadcrumb-container">
    <el-breadcrumb-item :to="{ path: '/' }" class="home-item">
      <i class="el-icon-s-home"></i>
      <span>首页</span>
    </el-breadcrumb-item>
    <el-breadcrumb-item
      v-for="(item, index) in breadcrumbList"
      :key="index"
      :to="index === breadcrumbList.length - 1 ? null : { path: item.path }"
      :class="{ 'last-item': index === breadcrumbList.length - 1 }"
    >
      {{ item.meta.title }}
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  name: 'AppBreadcrumb',
  computed: {
    breadcrumbList() {
      return this.$route.matched.filter(item => item.meta && item.meta.title);
    }
  }
};
</script>

<style scoped>
.breadcrumb-container {
  /* margin: 16px 0; */  
  padding: 12px 16px; 
  margin-bottom:10px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.breadcrumb-container:hover {
  
}

.breadcrumb-container >>> .el-breadcrumb__item {
  display: flex;
  align-items: center;
}

.breadcrumb-container >>> .el-breadcrumb__separator {
  margin: 0 8px;
  color: #c0c4cc;
  font-weight: normal;
}

.breadcrumb-container >>> .el-breadcrumb__inner,
.breadcrumb-container >>> .el-breadcrumb__inner a {
  color: #606266;
  font-weight: 500;
  transition: color 0.2s ease;
}

.breadcrumb-container >>> .el-breadcrumb__inner a:hover,
.breadcrumb-container >>> .el-breadcrumb__inner.is-link:hover {
  color: #409EFF;
  cursor: pointer;
}

.home-item >>> .el-breadcrumb__inner,
.home-item >>> .el-breadcrumb__inner a {
  color: #409EFF;
}

.home-item >>> .el-breadcrumb__inner a:hover,
.home-item >>> .el-breadcrumb__inner.is-link:hover {
  color: #66b1ff;
}

.last-item >>> .el-breadcrumb__inner {
  color: #303133;
  font-weight: 600;
  cursor: default;
}

.last-item >>> .el-breadcrumb__inner:hover {
  color: #303133;
  cursor: default;
}

/* 首页图标样式 */
.breadcrumb-container >>> .el-breadcrumb__inner i {
  margin-right: 4px;
  font-size: 16px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .breadcrumb-container {
    margin: 12px 0;
    padding: 8px 12px;
    font-size: 13px;
  }
  
  .breadcrumb-container >>> .el-breadcrumb__inner i {
    font-size: 14px;
  }
}
</style>